<template>
    <div class="list-container">
        <editable-list v-if="data"
                       :data="data"
                       :template="template"
                       @save-parent="save"/>
    </div>
</template>

<script>
	import ListMixin from "../mixins/ListMixin";
	import BlogService from "../services/BlogService";

	export default {
		name: "Blog",
		mixins: [ListMixin],
		created() {
			this.load();
		},
		data() {
			return {
				template: {
					_id: "",
                    lang: 0,
					title: "",
					synopsis: "",
                    image: "",
					date: () => new Date().toISOString()
				},
                backend: BlogService
			};
		}
	}
</script>

<style scoped lang="scss">
    .list-container {
        display: flex;
        position: relative;
        flex-direction: row;
        height: 100vh;
        overflow-y: hidden;
        justify-content: center;
    }
</style>